export default "__VITE_ASSET__a490ca35__"